import { inject, ref } from 'vue'

export function useConfig() {
    return {
        config: inject('config', ref({}))
    }
}